import { render, staticRenderFns } from "./monitoringAgentYear.vue?vue&type=template&id=4522a327"
import script from "./monitoringAgentYear.vue?vue&type=script&lang=js"
export * from "./monitoringAgentYear.vue?vue&type=script&lang=js"
import style0 from "./monitoringAgentYear.vue?vue&type=style&index=0&id=4522a327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports